import React from 'react';
import { Link } from 'react-router-dom';
import { PointsLogShape, PointsLeaderboardShape, UserShape } from '../shapes';
import DateMaster from '../stores/utils/date_master';
import Waiting from './waiting';

import PropTypes from 'prop-types';

export default class PointsLog extends React.Component {

  static propTypes = {
    user: UserShape,
    pointsLog: PointsLogShape,
    pointsLeaderboard: PointsLeaderboardShape,
    onLoadPointsLog: PropTypes.func,
    onLoadPointsLeaderboard: PropTypes.func
  }

  state = {
    month: new Date().toLocaleString('default', { month: 'long' })
  }

  componentDidMount() {
    this.props.onLoadPointsLeaderboard();
    this.props.onLoadPointsLog();
  }

  render() {
    if (this.props.pointsLog.get('loading')) {
      return this.renderLoading();
    } else if (this.props.pointsLog.get('log').size == 0) {
      return this.renderNoPoints();
    } else {
      return(
        <div className='board'>
          { this.renderPointsLogHeader() }
          { this.renderLeaderBoard() }
          { this.renderPointsLog() }
        </div>
      );
    }
  }

  renderLoading() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    )
  }

  renderNoPoints() {
    return (
      <div className='board'>
        { this.renderPointsLogHeader() }
        <div className='no-notifications'>
          <h4>Well, you haven't earned any points, yet.</h4>
          <div className='action'>
            <Link to='/' className='btn btn-dark'>Tack a word to get 10 points</Link>
          </div>
        </div>
      </div>
    )
  }

  renderPointsLogHeader() {
    return (
      <div className='header'>
        <h1>{ this.state.month } Points Board</h1>
        <p className='item-meta'>
          You've earned <b>{ `${ this.props.user.get('points').toLocaleString() }` }</b> points so far this month.
        </p>
      </div>
    );
  }

  renderLeaderBoard() {
    if (this.props.pointsLeaderboard.get('leaders').size > 1) {
      const leaderBoard = this.props.pointsLeaderboard.get('leaders').map((leaderBoardItem, i) => {
        return this.renderLeaderBoardItem(i, leaderBoardItem);
      });
      return (
        <div className='leader-board give-me-50-below'>
          <p className='item-meta'>How you stack in { this.state.month } against people you follow and who follow you.</p>
          <ul className='list-group'>{ leaderBoard }</ul>
        </div>
      )
    } else return null;
  }

  renderLeaderBoardItem(key, leaderBoardItem) {
    return (
      <li key={ key } className='leaderboard-item list-group-item'>
        <div className='row'>
          <div className='col-2'>{ key + 1 }</div>
          <div className='col item-meta'><h4>{ leaderBoardItem.get('points').toLocaleString() } points</h4></div>
          <div className='col item-meta'><Link to={`/people/${ leaderBoardItem.get('slug') }`}>{ leaderBoardItem.get('userName') }</Link></div>
        </div>
      </li>
    )
  }

  renderPointsLog() {
    const pointsLog = this.props.pointsLog.get('log').map((pointsLogItem, i) => {
      return this.renderPointsLogItem(i, pointsLogItem);
    });
    if (pointsLog.size > 0) {
      return (
        <div className='board-notification-group'>
          <ul className='list-group'>{ pointsLog }</ul>
        </div>
      );
    } else return null;
  }

  renderPointsLogItem(i, pointsLogItem) {
    return (
      <li key={ i } className='list-group-item secondary-background'>
        <div className='row'>
          <div className='col-sm-2'>
            <h4>+ { pointsLogItem.get('points') }</h4>
          </div>
          <div className='col-sm-6 item-meta'>{ pointsLogItem.get('description') }</div>
          <div className='col-sm-4 item-meta'>{ `${ DateMaster.timeSince(pointsLogItem.get('createdAt')) } ago` }</div>
        </div>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/points_board.jsx